import React from "react";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../ui/select";
import { Input } from "../ui/input";
import { cn } from "../../lib/utils";

export const CANCELLATION_REASONS = [
  "Product Stock not available",
  "Pincode not serviceable",
  "Low Order Value",
  "Customer requested cancellation",
  "Duplicate order",
  "Cold Chain Products",
  "Other",
];

interface CancellationReasonsProps {
  value: string;
  onChange: (value: string) => void;
  required?: boolean;
}

export const CancellationReasons: React.FC<CancellationReasonsProps> = ({
  value,
  onChange,
  required = true,
}) => {
  const [isOtherSelected, setIsOtherSelected] = React.useState(false);

  const isPredefinedReason = CANCELLATION_REASONS.includes(value);

  const showCustomInput = isOtherSelected || (value && !isPredefinedReason);

  const handleValueChange = (selectedValue: string) => {
    if (selectedValue === "Other") {
      setIsOtherSelected(true);
      onChange("");
    } else {
      setIsOtherSelected(false);
      onChange(selectedValue);
    }
  };

  const handleCustomReasonChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange(e.target.value);
  };

  const selectDisplayValue = isPredefinedReason
    ? value
    : showCustomInput
      ? "Other"
      : "";

  return (
    <div className="space-y-2">
      <Select value={selectDisplayValue} onValueChange={handleValueChange}>
        <SelectTrigger
          id="cancellation-reason"
          className="w-full dark:bg-gray-800 dark:text-white dark:border-gray-700"
        >
          <SelectValue placeholder="Select a reason" />
        </SelectTrigger>
        <SelectContent className="dark:bg-gray-800 dark:text-white dark:border-gray-700">
          {CANCELLATION_REASONS.map(reason => (
            <SelectItem key={reason} value={reason}>
              {reason}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      {showCustomInput && (
        <Input
          type="text"
          placeholder="Enter custom reason"
          value={value}
          onChange={handleCustomReasonChange}
          className={cn(
            "w-full dark:bg-gray-800 dark:text-white dark:border-gray-700",
            "mt-2",
          )}
        />
      )}
    </div>
  );
};

export default CancellationReasons;
